import { FormActivity } from './form-activity';
import { Activity, ActivityModel, ScreenActivity } from './activity';
import { Utilities, ActivityUtilities } from 'src/app/services';

export class ReviewContractorRegistrationActivity extends ScreenActivity<
  ActivityModel
> {
  previousActivities: Activity<ActivityModel>[];

  constructor(options?: Partial<ReviewContractorRegistrationActivity>) {
    super(options);
    this.type = 'review-contractor-registration-activity';
    this.name = 'Review Contractor Registration';
    this.description =
      'Use this activity to set the entry point for the contractor registration review process.';

    if (options) {
      Object.assign(this, options);
    }

    if (options) {
      this.model = new ActivityModel(options.model);
    } else {
      this.model = new ActivityModel();
    }

    this.model.screenName =
      this.model.screenName || 'Review Contractor Registration';

    if (this.previousActivities) {
      const aObjs = ActivityUtilities.convertActivitiesJsonToClasses(
        this.previousActivities
      );
      const activities: Activity<ActivityModel>[] = [];

      for (const a in aObjs) {
        activities.push(aObjs[a]);
      }
      this.previousActivities = activities;
    }
  }
}
